import Vue from 'vue'
import Vue2MapboxGL from 'vue2mapbox-gl'

import 'mapbox-gl/dist/mapbox-gl.css'

Vue.use(Vue2MapboxGL)
